import { left } from 'fp-ts/Either';
import { httpClientFunction } from 'domain/types';
import { UpdateDashboardFrameClient } from 'use-case/dashboard/update/updateDashboardClient';

import { callbackParseDashboardResponse } from 'adapter/out/client/dashboard/callbackParseDashboardResponse';
import { UpdateDashboardFrameCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardFrameCriteria';

export default (httpClient: httpClientFunction, baseUrl: string): UpdateDashboardFrameClient => (criteria: UpdateDashboardFrameCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.id}`, {
        method: 'PATCH',
        body: JSON.stringify(asDashboardJson(criteria)),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) => callbackParseDashboardResponse(response))
        .catch(() => left({ error: new Error(), status: 503 }));

export const asDashboardJson = (criteria: UpdateDashboardFrameCriteria): DashboardUpdateFrameJsonRequest => ({
    frame: {
        header: {
            logo: criteria.frame.header.logo,
            template_name: criteria.frame.header.templateName,
            period: criteria.frame.header.period,
            location: criteria.frame.header.location,
        },
        footer: {
            generation_date: criteria.frame.footer.generationDate,
            page_number: criteria.frame.footer.pageNumber,
        },
    }
});

export type DashboardUpdateFrameJsonRequest = {
    frame: {
        header: {
            logo: boolean;
            ['template_name']: boolean;
            period: boolean;
            location: boolean;
        };
        footer: {
            ['generation_date']: boolean;
            ['page_number']: boolean;
        };
    };
};
